import request from "../../utils/request";

export function getFormById(siteId, formId) {
    return request({
        url: `/formPublic/get-form/${formId}/${siteId}`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
    });
}

export function submitForm(siteId, formData) {
    return request({
        url: "/formPublic/form-submissions",
        method: "post",
        headers: {
            "site-id": siteId,
            "Content-Type": "application/json",
        },
        data: formData,
    });
}